import './src/styles/global.css'

export const registerServiceWorker = () => true
